import { SITE_PAGE } from '@/features/common/layout/publicPageLinks';
import type { PublicRegistryKey } from '@/i18n/dictionaries/publicRegistry';

/**
 * Every public destination, in one list.
 *
 * Deliberately not generated from the footer's columns even though they overlap: the footer is a
 * curated selection and this is meant to be exhaustive, so deriving one from the other would let
 * a page drop off the sitemap the moment someone tidied the footer.
 */
export const SITEMAP: [string, PublicRegistryKey][] = [
  ['/', 'navHome'],
  [SITE_PAGE.presentation, 'sitemapAbout'],
  ['/instruiri', 'trainingsHeading'],
  ['/consilieri', 'advisorsHeading'],
  ['/servicii', 'servicesHeading'],
  ['/biblioteca', 'libraryHeading'],
  ['/cercetare', 'researchHeading'],
  ['/finantare', 'fundingHeading'],
  ['/agentii-sprijin', 'agenciesHeading'],
  ['/comunitate', 'communityHeading'],
  // Omitted until now, though it is a primary destination in the header nav — which is
  // exactly the failure mode the comment above warns about, arrived at by hand instead of
  // by derivation. A visitor using this page as the site's index missed the hub entirely.
  ['/catalog', 'sitemapCatalog'],
  ['/evenimente', 'sitemapEvents'],
  ['/stiri', 'sitemapNews'],
  ['/harta', 'sitemapMap'],
  ['/cautare', 'sitemapSearch'],
  ['/contact', 'sitemapContact'],
  ['/politici/utilizare', 'sitemapTerms'],
  ['/politici/confidentialitate', 'sitemapPrivacy'],
  ['/politici/cookies', 'sitemapCookies'],
  [SITE_PAGE.accessibility, 'sitemapAccessibility'],
];
